import React from "react";
import "./HeroSection.scss";

interface HeroSectionProps {
  title: string;
  subtitle: string;
}

const HeroSection: React.FC<HeroSectionProps> = ({ title, subtitle }) => (
  <section className="hero-section">
    <div className="hero-overlay"></div>
    <div className="hero-content">
      <h1>{title}</h1>
      <p className="hero-subtitle">{subtitle}</p>
    </div>
    <a
      href={process.env.PUBLIC_URL + "/NRWC State of the Reentry Workforce.pdf"}
      download="NRWC State of the Reentry Workforce 2025.pdf"
      className="download-button"
      id="download-report-button"
    >
      Download PDF
    </a>
  </section>
);

export default HeroSection;
